export const borderRadius = [
  '0.1875rem',
  '0.375rem',
  '0.5rem',
  '1.25rem',
  '6.25rem',
  '50%',
]
